import { render, staticRenderFns } from "./TipoLeilao.vue?vue&type=template&id=d49442c4&scoped=true&"
import script from "./TipoLeilao.vue?vue&type=script&lang=js&"
export * from "./TipoLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49442c4",
  null
  
)

export default component.exports